// extracted by mini-css-extract-plugin
export default {"OrderItem":"styles_OrderItem__kwVSy","OrderItem__selected":"styles_OrderItem__selected__PQcXG"};